<template>
  <div :is="pullRefresh ? 'van-pull-refresh' : 'div'" v-model="isLoading" @refresh="refresh">
    <van-list class="list" v-model="isLoading" :finished="isFinished || isError" @load="getList" >
      <router-link v-for="item in list" :to="{path: link + item.id, query: linkQuery}" >
        <slot :item="item"></slot>
      </router-link>
      <list-foot v-if="isFinished"><slot name="finish"></slot></list-foot>
      <list-foot v-if="isError" @click.native="getGalleryList"><slot name="error">出错了</slot></list-foot>
    </van-list>
  </div>
</template>

<script>
  import { getArticleList } from '@/api/common'
  import ListFoot from '@/components/ListFoot'
  import {List, PullRefresh} from 'vant'
  
  import Vue from 'vue';
  Vue.use(List).use(PullRefresh)

  export default {
    name: 'List',
    components: { ListFoot, },
    props: {
      type: {
        type: String,
        required: true,
      },
      options: {
        type: Object,
      },
      link: {
        type: String,
        default: '/article/detail/',
      },
      linkQuery: {
        type: Object,
        default: () => {return {}}
      },
      pullRefresh: {
        type: Boolean,
        default: true,
      },
      filter: Function
    },
    data() {
      return {
        list: [],
        page: 1,
        isLoading: false,
        isFinished: false,
        isError: false,
      }
    },
  
    methods: {
      async getList() {
        this.isLoading = true
        this.isError = false
        this.isFinished = false

        let list = await getArticleList(this.type, this.page, this.options).catch(() => {
          this.isLoading = false
          this.isError = true
          this.isFinished = true
          this.$emit('error')
        })

        if(typeof this.filter === 'function') {
          list = this.filter(list)
        }

        if (this.page === 1) {
          this.list = list
        } else {
          this.list = [...this.list, ...list]
        }
        this.page += 1
        this.isLoading = false

        // 20是默认的pageSize，返回少于20说明没有更多数据了
        if (list.length < 20) {
          this.isFinished = true
          this.$emit('finish')
          return
        }

        this.$emit('load')
      },

      refresh() {
        this.page = 1
        this.getList()
      }
    },

    created() {
      this.getList()
    }, 
  }
</script>

<style scoped lang="less">
 
</style>